import React, { useContext } from "react";

import { useCloudFileDashboard } from "../../../../../common/context/useCloudFileDashboard";
import { useCloudFilePreviewContext } from "../../hooks/useCloudFilePreviewContext";
import { VideoRekognitionResultContext } from "../../rekognition/context/VideoRekognitionResultContext";

export const useVideoFilePreviewSection = () => {
    const { isPreviewLoading, filePreview, reloadPreview, cloudFileDetails } = useCloudFilePreviewContext();
    const { isLoading: isResultLoading } = useContext(VideoRekognitionResultContext);
    const { selectedVersionInfo } = useCloudFileDashboard();

    const [lastLoadedVersionIds, setLastLoadedVersionIds] = React.useState<string | undefined>(undefined);

    return {
        reloadPreview,
        cloudFileDetails,
        filePreview,
        selectedVersionInfo,
        lastLoadedVersionIds,
        setLastLoadedVersionIds,
        isLoading: isPreviewLoading && isResultLoading
    };
};
